// extracted by mini-css-extract-plugin
export default {"btn":"RegisterButton_btn__KY9rw"};